// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2ba_w","approved":"Status_approved__1QNiA","rejected":"Status_rejected__1x063","expired":"Status_expired__2vnXY","label":"Status_label__2lGR8"};